module.exports = __webpack_public_path__ + "media/icons/badanie-techniczne@3x-07fe69f0.svg";